// import {initTouchScroll} from "./tools/initTouchScroll";
import {getMarkersData} from "./tools/getMarkersData";
import {initMap} from "./tools/initMap";
import {initObjectManager} from "./tools/initObjectManager";
import {createMarkers} from "./tools/createMarkers";
import {initDivSlider} from "./components/div.slider";
import {MAPS} from "./constants";

export const initYandexMap = () => {
	ymaps.ready( () => {
		MAPS.forEach( ( mapNode, i ) => {
			const id = mapNode.getAttribute(`id`);
			const center = [mapNode.getAttribute(`data-latitude`), mapNode.getAttribute(`data-longitude`)];
			const zoom = mapNode.getAttribute(`data-zoom`);

			const ymapsObjectManager = initObjectManager();
			const markersData = getMarkersData(id);

			if ( markersData.length > 0 )
			{
				const markers = createMarkers(markersData);
				
				ymapsObjectManager.add( markers );
			}
			
			const ymapsMap = initMap(mapNode, ymapsObjectManager, id, center, zoom);
			ymapsMap.geoObjects.add(ymapsObjectManager);
			
			// initTouchScroll(ymapsMap);
			
			initDivSlider(ymapsMap, ymapsObjectManager);

			ymapsMap.container.getParentElement().classList.add( `loaded` );
		});
	});
};
